export default "__VITE_PUBLIC_ASSET__e44c60b2__"